// extracted by mini-css-extract-plugin
export default {"modal":"Ads_modal__gwR3G","content":"Ads_content__H7Q42"};